<div class="cwt-plp-np col-lg-4 pr-0 float-left mb-3 p-res-0 product-res-grid">

  <div class="products-grid1" id="productsGrid">
    <div class="product-card" (click)="goToDetail($event)">
      <div role="button" class="product-image" >
        <div class="product-image-content">
          <div class="col-lg-12 p-0 d-flex product-image justify-content-center mb-3">
            <cx-media [container]="product?.images?.PRIMARY" [format]="'product'" [alt]="product?.summary"></cx-media>
          </div>
          <div class=""></div>
        </div>
      </div>
      <div class="product-info">
        <h3  role="button" class="product-title">{{ product?.marketingName ? product.marketingName : product.name }}</h3>
        <p  role="button" class="product-description">{{product?.description}}</p>
        <div  role="button" class="product-price" data-price="45.99">
          <!-- (product?.callForPricing?.toLowerCase?.() === 'yes' && product?.pricingText)
          || product?.price?.netPrice}} -->
          @if (product?.price?.netPrice && product?.marketingUom) {
            <span>
              ${{ formatPrice(product?.price?.netPrice) }}/{{ product?.marketingUom }}
            </span>
          }


        </div>
        <div class="product-actions">
          <div class="quantity-section">
            <div class="quantity-label" title="{{ 'cartItems.quantityTitle' | cxTranslate }}">
              {{ 'cartItems.quantity' | cxTranslate }}
            </div>
            <div class="cx-value">
              <cx-item-counter  [control]="addToCartForm.get('quantity')" [max]="99">
              </cx-item-counter>
            </div>
          </div>

          <kn-br-add-to-cart [plpQuantity]="addToCartForm.get('quantity').value" [type]="'PLP'" [product]="product">
          </kn-br-add-to-cart>
        </div>
      </div>
    </div>

  </div>
</div>